import keys from 'constants/keys'
import { IConfigStateGroups } from 'constants/interfaces'
import { getTokenFromCookie } from 'utils'

// Jotform forms hosted at forms.storee.ai (and any link explicitly flagged "external") read caller-identity
// off the query string to pre-fill / attribute a submission. Tasks (external-link subtasks) and Library
// (jotform links dropped in as Drive links) both need that same query string, built the same way — this is
// the shared place for both the gate and the builder so the two features can't drift apart on either.
export const isExternalFormLink = (link: string): boolean =>
  link.includes(keys.EXTERNAL_LINK_PHRASE) || link.includes(keys.FORMS_STOREE)

interface IIdentityParams {
  first_name?: string | null
  last_name?: string | null
  default_group?: string | null
  groups?: IConfigStateGroups
  user_id?: string | null
  token?: string
}

// Appends token/first_name/last_name/branch_name(=default group's name)/user_id, plus whatever
// feature-specific `extraParams` the caller tacks on (e.g. Tasks' task_id/subtask_id/recipient_type).
// Params that are null/undefined are dropped rather than serialized as "undefined".
export const appendIdentityParams = (
  link: string,
  { first_name, last_name, default_group, groups, user_id, token = getTokenFromCookie() }: IIdentityParams,
  extraParams: Record<string, string | number | boolean | null | undefined> = {}
): string => {
  const params: Record<string, string | number | boolean | null | undefined> = {
    token,
    first_name,
    last_name: last_name ?? '',
    branch_name: default_group ? groups?.[default_group]?.name : '',
    user_id,
    ...extraParams,
  }
  const queryString = Object.keys(params)
    .filter((key) => params[key] !== null && params[key] !== undefined)
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(String(params[key]))}`)
    .join('&')
  return queryString ? `${link}?${queryString}` : link
}
